import type { Prisma, TaskStatus, DocumentType } from "@prisma/client";
import { fetchGet, fetchPost, fetchPut } from "@/utils/fetch";

const baseURL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:3000/api";

const verifyPhoneCode = (phone: string, code: string) => {
  return fetchPost(`${baseURL}/phone/code/verify`, {
    body: JSON.stringify({ phone, code }),
  });
};

const updateUser = (user: Prisma.UserUpdateInput) => {
  return fetchPut(`${baseURL}/user`, {
    body: JSON.stringify(user),
  });
};

const generatePhoneCode = (phone: string) => {
  return fetchPost(`${baseURL}/phone/code/generate`, {
    body: JSON.stringify({ phone }),
  });
};

const savePassport = (
  data: { [key: string]: string | Date | null },
  dealId: string
) => {
  return fetchPost(`${baseURL}/passport`, {
    body: JSON.stringify({ data, dealId }),
  });
};

const uploadPassport = (imageData: FormData) => {
  return fetchPost(`${baseURL}/passport/upload`, {
    body: imageData,
  });
};

const uploadBirthCertificate = (data: FormData) => {
  return fetchPost(`${baseURL}/document`, {
    body: data,
  });
};

const uploadDocument = (data: FormData) => {
  return fetchPost(`${baseURL}/document`, {
    body: data,
  });
};

const syncPipeAndLoadDealsByEmail = async () => {
  return fetchGet(`${baseURL}/pipedrive-sync-email`);
};

const saveFcmToken = (fcmToken: string) => {
  return fetchPost(`${baseURL}/fcm`, {
    body: JSON.stringify({ fcmToken }),
  });
};

const sendDocumentToTask = (data: FormData) => {
  return fetchPost(`${baseURL}/task/upload-file`, {
    body: data,
  });
};

const getMailMessage = (id: string) => {
  return fetchGet(`${baseURL}/mail-message/${id}`);
};

const finishTaskReview = (
  taskId: string,
  status: TaskStatus,
  documentId: string,
  documentType: DocumentType,
  feedback?: string
) => {
  return fetchPost(`${baseURL}/task/review/${taskId}`, {
    body: JSON.stringify({ feedback, status, documentId, documentType }),
  });
};

const validateEmail = (email: string) => {
  return fetchPost(`${baseURL}/auth/validate-email`, {
    body: JSON.stringify({ email }),
  });
};

export {
  verifyPhoneCode,
  generatePhoneCode,
  updateUser,
  savePassport,
  uploadPassport,
  uploadBirthCertificate,
  uploadDocument,
  syncPipeAndLoadDealsByEmail,
  saveFcmToken,
  sendDocumentToTask,
  getMailMessage,
  finishTaskReview,
  validateEmail,
};
